import {createEditableWrapper, createEditButton} from '../ui-elements';
import {openTextEditor} from '../text-editor';
import {openImageEditor} from '../image-editor';
import {openYoutubeEditor} from '../youtube-editor';
import {openDocumentEditor} from '../document-editor';
import {extractFilenameFromPath} from '../../../utils/api';
import {config, getApiBaseUrl} from "../../../config/app-config";

export const eventHandlers = new Set();

export function setupEditableElements() {
    const contentElements = document.querySelectorAll('[data-content]');
    contentElements.forEach(setupEditButton);

    // Additionally add handlers for documents
    setupDocumentDownloadHandlers();
}

// Function to setup document download handlers
export function setupDocumentDownloadHandlers() {
    // Find all .cooperation-docs elements
    const documentElements = document.querySelectorAll('.cooperation-docs[data-type="document"], .cooperation-docs[data-attribute="document"]');

    documentElements.forEach((element) => {
        // Find dropdown icon inside element
        const dropdownIcon = element.querySelector('img[src*="Dropdown"]');

        if (dropdownIcon) {
            // Make icon more noticeable
            dropdownIcon.style.cursor = 'pointer';
            dropdownIcon.title = 'Download document';

            // Add class for obvious interactivity indication
            dropdownIcon.classList.add('document-download-button');

            // Remove old handlers if they exist
            const oldHandlers = Array.from(eventHandlers).filter(
                handler => handler.element === dropdownIcon && handler.type === 'click'
            );

            oldHandlers.forEach(handler => {
                dropdownIcon.removeEventListener(handler.type, handler.handler);
                eventHandlers.delete(handler);
            });

            // Create new click handler
            const handleClick = function (e) {
                e.preventDefault();
                e.stopPropagation();

                // Get file path from attribute
                const mediaPath = element.getAttribute('data-media-path');

                if (!mediaPath) {
                    console.error('No media path found for element:', element);
                    alert('Error: document path not found');
                    return;
                }

                // Extract filename from path
                const filename = extractFilenameFromPath(mediaPath);

                if (!filename) {
                    console.error('Could not extract filename from path:', mediaPath);
                    alert('Error: cannot determine filename');
                    return;
                }

                // Form download URL
                const baseUrl = getApiBaseUrl();
                const downloadUrl = `${baseUrl}${config.api.paths.documentDownload}/${filename}`;

                // Use direct approach via window.location
                window.location.href = downloadUrl;
            };

            // Add click handler to icon
            dropdownIcon.addEventListener('click', handleClick);
            eventHandlers.add({element: dropdownIcon, type: 'click', handler: handleClick});

            // Add additional visual indicator
            dropdownIcon.classList.add('download-enabled');
        }
    });
}

export function setupEditButton(element) {
    const parentWrapper = element.parentNode;
    if (parentWrapper && parentWrapper.classList.contains('editable-wrapper')) {
        return;
    }

    const wrapper = createEditableWrapper(element);
    const editBtn = createEditButton();

    if (element.parentNode) {
        element.parentNode.insertBefore(wrapper, element);
        wrapper.appendChild(element);
        wrapper.appendChild(editBtn);

        const handleEditClick = (e) => {
            e.preventDefault();
            e.stopPropagation();

            // Get current element attributes
            const contentId = element.getAttribute('data-content');
            const contentType = element.getAttribute('data-type');
            const dataAttribute = element.getAttribute('data-attribute');

            // For elements with data-content="youtube-video" always open YouTube editor
            if (contentId === 'youtube-video') {
                // Force set attribute before opening editor
                element.setAttribute('data-attribute', 'video');
                openYoutubeEditor(element);
            } else if (contentType === 'image') {
                openImageEditor(element);
            } else if (contentType === 'document' || dataAttribute === 'document') {
                // Add handling for document type
                openDocumentEditor(element);
            } else {
                openTextEditor(element);
            }
        };

        editBtn.addEventListener('click', handleEditClick);
        eventHandlers.add({element: editBtn, type: 'click', handler: handleEditClick});
    }
}

export function cleanupEventHandlers() {
    eventHandlers.forEach(handler => {
        handler.element.removeEventListener(handler.type, handler.handler);
    });
    eventHandlers.clear();
}